import React from "react";
import { StyledExperience } from "./styles/Experience.styled";
import { SectionHeading, SectionTitle } from "../styles/SectionHeading";
import TimeLine from "./TimeLine";

const Experiences = () => {
  return (
    <StyledExperience id="experiences">
      <SectionHeading>
        <SectionTitle dark="true" number="03">Experiences</SectionTitle>
      </SectionHeading>     
      <TimeLine/>
    </StyledExperience>
  );
};

export default Experiences;
